module.exports = __webpack_public_path__ + "img/expostyle_0041_grass_green_pantone7731c.4d7cdfbb.jpg";